module.exports = "<div class=\"container\"><div class=\"columns\"><div class=\"column has-text-centered\"><img class=\"logo\" src=\"assets/images/logo.jpg\"/></div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/main/main.pug
// module id = 54
// module chunks = 0